import styled from "@emotion/styled";

export const Icon = styled('img')({
    height: "25px",
    width: "25px",
    marginLeft: "2px",
    marginBottom: "-6px",
});